import Vue from "vue";
import VueProgressBar from 'vue-progressbar'
import App from "./App";
import router from "./router";
import store from "./store";
import VueHtmlToPaper from 'vue-html-to-paper';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import Toasted from 'vue-toasted';

Vue.config.productionTip = false;

if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }

            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];

            // 5. Let k be 0.
            var k = 0;

            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }

            // 7. Return undefined.
            return undefined;
        }
    });
}
const options = {
    color: '#edc239',
    failedColor: '#874b4b',
    thickness: '5px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
}

 
Vue.use(Datetime)
Vue.use(VueProgressBar, options)
Vue.use(Toasted)


const options_html_paper = {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=yes'
    ],
    styles: [
        'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
        'https://unpkg.com/kidlat-css/css/kidlat.css'
    ]
}

Vue.use(VueHtmlToPaper, options_html_paper);

Vue.mixin({
    methods: {
        userOfType: function() {
            for (var i = 0; i < arguments.length; i++) {
                if(this.user().user_type === arguments[i]) {
                    return true;
                }
            }
            return false;
        },
        user: function() { 
            var data = window.localStorage.getItem("user");
            if(data) 
                return JSON.parse(data);
            return null;                 
        },
        buildError(e) {
            if(e.response && e.response.data && e.response.data.message) {
                return e.response.data.message
            }
            return `${e}`
        },
        error(message) {
            this.$toasted.error(message,{ 
                theme: "bubble", 
                position: "bottom-right", 
                duration : 5000
           })
        },
        info(message) {
            this.$toasted.info(message,{ 
                theme: "bubble", 
                position: "bottom-right", 
                duration : 5000
           })
        },
        success(message) {
            this.$toasted.success(message,{ 
                theme: "bubble", 
                position: "bottom-right", 
                duration : 5000
           })
        }
    }
});

export default new Vue({
    ...App,
    router,
    store,
    render: h => h(App)
}).$mount("#app");
